import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35} from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo06: React.createRef(),
    grupo07: React.createRef(),
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo11: React.createRef(),
    grupo12: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo06: false,
    grupo07: false,
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo11: false,
    grupo12: false,
    grupo13: false,
    grupo14: false,
    grupo17: false,
    grupo18: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      console.log(`Status das luzes: ${statusDasLuzesFlex35}`);
      setLoading(false);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8000);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo06: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo07: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo08: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo09: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo10: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
      grupo11: statusDasLuzesFlex35.includes("1O10") && !statusDasLuzesFlex35.includes("1O00"),
      grupo12: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo13: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo14: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo17: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo18: statusDasLuzesFlex35.includes("1G10") && !statusDasLuzesFlex35.includes("1G00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return <div></div>;
  }

  return (
    <div id="BotoesMobile">
      <h2 id='Title-botoes-Mobile'>Lazer 2</h2>
      <div className="campoBotoesAcionamento-mobile" id="page03">
        <div
          ref={groupRefs.current.grupo06}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo06', !imageStates.grupo06);
            sendCommandFlex35('Quadra 01', imageStates.grupo06 ? '1A00' : '1A10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo06 ? 'Highlighted-mobile' : ''}`}>06</p>
          <p className="textBar-mobile">Quadra 01</p>
        </div>
        <div
          ref={groupRefs.current.grupo07}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo07', !imageStates.grupo07);
            sendCommandFlex35('Quadra 02', imageStates.grupo07 ? '1B00' : '1B10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo07 ? 'Highlighted-mobile' : ''}`}>07</p>
          <p className="textBar-mobile">Quadra 02</p>
      </div>
      <div
          ref={groupRefs.current.grupo08}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo08', !imageStates.grupo08);
            sendCommandFlex35('Pergolado', imageStates.grupo08 ? '1F00' : '1F10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo08 ? 'Highlighted-mobile' : ''}`}>08</p>
          <p className="textBar-mobile">Pergolado</p>
        </div>
        <div
          ref={groupRefs.current.grupo09}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo09', !imageStates.grupo09);
            sendCommandFlex35('Piscina', imageStates.grupo09 ? '1M00' : '1M10');
          }}
        > 
          <p className={`NumberTextBar-mobile${imageStates.grupo09 ? 'Highlighted-mobile' : ''}`}>09</p>
          <p className="textBar-mobile">Piscina</p>
        </div>
        <div
          ref={groupRefs.current.grupo10}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo10', !imageStates.grupo10);
            sendCommandFlex35('Piscina Infantil', imageStates.grupo10 ? '1L00' : '1L10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo10 ? 'Highlighted-mobile' : ''}`}>10</p>
          <p className="textBar-mobile">Piscina Infantil</p>
        </div>
        <div
          ref={groupRefs.current.grupo11}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo11', !imageStates.grupo11);
            sendCommandFlex35('Floreira Piscina', imageStates.grupo11 ? '1O00' : '1O10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo11 ? 'Highlighted-mobile' : ''}`}>11</p>
          <p className="textBar-mobile">Floreira Piscina</p>
        </div> 
        <div
          ref={groupRefs.current.grupo12}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo12', !imageStates.grupo12);
            sendCommandFlex35('Escada Poste', imageStates.grupo12 ? '1N00' : '1N10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo12 ? 'Highlighted-mobile' : ''}`}>12</p>
          <p className="textBar-mobile">Escada Poste</p>
        </div>
        <div
          ref={groupRefs.current.grupo13}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo13', !imageStates.grupo13);
            sendCommandFlex35('Floreira + Garden Gourmet', imageStates.grupo13 ? '1J00' : '1J10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo13 ? 'Highlighted-mobile' : ''}`}>13</p>
          <p className="textBar-mobile">Floreira + Gourmet</p>
        </div>
        <div
          ref={groupRefs.current.grupo14}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo14', !imageStates.grupo14);
            sendCommandFlex35('Floreira + Espaço Kids', imageStates.grupo14 ? '1K00' : '1K10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo14 ? 'Highlighted-mobile' : ''}`}>14</p>
          <p className="textBar-mobile">Floreira + Espaço Kids</p>
        </div>
        <div
          ref={groupRefs.current.grupo17}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo17', !imageStates.grupo17);
            sendCommandFlex35('Hall Elevador + Varanda', imageStates.grupo17 ? '1P00' : '1P10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo17 ? 'Highlighted-mobile' : ''}`}>17</p>
          <p className="textBar-mobile">Hall Elevador + Varanda</p>
        </div>
        <div
          ref={groupRefs.current.grupo18}
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo18', !imageStates.grupo18);
            sendCommandFlex35('Muro da Piscina', imageStates.grupo18 ? '1G00' : '1G10');
          }}
        >
          <p className={`NumberTextBar-mobile${imageStates.grupo18 ? 'Highlighted-mobile' : ''}`}>18</p>
          <p className="textBar-mobile">Muro da Piscina</p>
        </div>
      </div>
    </div>
  );

}

export default BotoesMobile;